import controller from './alert.controller';
import template from './alert.component.html';

const AlertComponent = {
  template,
  controller,
};

export default AlertComponent;
